import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPageV2 } from './pages/LoginPageV2';
import { HomePage } from './pages/HomePage';
import { DashboardPage } from './pages/DashboardPage';
import AuditPageV2 from './pages/AuditPageV2';
import PreAuditProV3 from './pages/PreAuditProV3';
import { PreAuditPDFLePresident } from './pages/PreAuditPDFLePresident';
import { PreAuditProLePresident } from './pages/PreAuditProLePresident';
import { HotelPartnershipsPage } from './pages/HotelPartnershipsPage';
import { TestPage } from './pages/TestPage';
import { KeywordsPage } from './pages/KeywordsPage';
import { GeoPage } from './pages/GeoPage';
import { ChatbotPage } from './pages/ChatbotPage';
import { BacklinksPage } from './pages/BacklinksPage';
import { ProposalPage } from './pages/ProposalPage';
import { LexiquePage } from './pages/LexiquePage';
import { SettingsPage } from './pages/SettingsPage';
import { AdministrationPage } from './pages/AdministrationPage';
import TestSupabasePage from './pages/TestSupabasePage';
import { CafeMaxContractPage } from './pages/CafeMaxContractPage';
import { ReportsPage } from './pages/ReportsPage';
import { TimeEstimationPage } from './pages/TimeEstimationPage';

const AppRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Route publique : Login */}
        <Route
          path="/login"
          element={user ? <Navigate to="/" replace /> : <LoginPageV2 />}
        />

        {/* Route publique standalone : Pre-Audit Le President */}
        <Route
          path="/pre-audit-pro-president"
          element={<PreAuditProLePresident />}
        />

        {/* Routes protégées : Nécessitent authentification */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  {/* Routes accessibles par tous (admin + client) */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/audit" element={<AuditPageV2 />} />
                  <Route path="/pre-audit" element={<PreAuditProV3 />} />
                  <Route path="/pre-audit-pdf-president" element={<PreAuditPDFLePresident />} />
                  <Route path="/keywords" element={<KeywordsPage />} />
                  <Route path="/geo" element={<GeoPage />} />
                  <Route path="/hotels" element={<HotelPartnershipsPage />} />
                  <Route path="/test" element={<TestPage />} />
                  <Route path="/backlinks" element={<BacklinksPage />} />
                  <Route path="/lexique" element={<LexiquePage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/cafe-max-contract" element={<CafeMaxContractPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/time-estimation" element={<TimeEstimationPage />} />

                  {/* Routes réservées aux ADMINS uniquement */}
                  <Route
                    path="/administration"
                    element={
                      <ProtectedRoute requireAdmin>
                        <AdministrationPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/proposal"
                    element={
                      <ProtectedRoute requireAdmin>
                        <ProposalPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/chatbot"
                    element={
                      <ProtectedRoute requireAdmin>
                        <ChatbotPage />
                      </ProtectedRoute>
                    }
                  />

                  {/* Routes de test (admin uniquement) */}
                  <Route
                    path="/test-supabase"
                    element={
                      <ProtectedRoute requireAdmin>
                        <TestSupabasePage />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

const AppV2: React.FC = () => {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default AppV2;


